import { Box, TextButton } from '@zillow/constellation-10';
import { IconChevronLeftFilled } from '@zillow/constellation-icons';
import type { Address, YourRentalListingSectionDto } from '@zg-rentals/ts-your-rental-api-client';
import PropertySection from './PropertySection';
import PropertySectionError from './PropertySectionError';
import EmptyHeader from './EmptyHeader';

const CONTENT = {
  BREADCRUMB_LINK: 'Back to ',
} as const;

type HeaderProps = {
  isLoggedIn: boolean;
  hasMultipleRentals: boolean;
  listingSection?: YourRentalListingSectionDto;
  showBreadcrumb: boolean;
  breadcrumbAddress?: Address;
  contactIreneModal?: React.ReactNode;
  viewRentalsModal?: React.ReactNode;
  addRentalModal?: React.ReactNode;
  onBreadcrumbClick?: () => void;
};

type BreadcrumbProps = {
  address: Address;
  onClick: () => void;
};

const Breadcrumb = ({ address, onClick }: BreadcrumbProps) => {
  const addressWithUnit = `${address.street}${address.unit ? ` #${address.unit}` : ''}`;
  return (
    <TextButton
      data-testid="Header-Breadcrumb"
      icon={<IconChevronLeftFilled />}
      textStyle="body-bold"
      css={{ justifyContent: 'flex-start' }}
      onClick={onClick}
      aria-label={`Go back to ${address}`}
    >
      {CONTENT.BREADCRUMB_LINK}
      {addressWithUnit}
    </TextButton>
  );
};

const Header = ({
  isLoggedIn,
  listingSection,
  hasMultipleRentals,
  showBreadcrumb,
  breadcrumbAddress,
  contactIreneModal,
  viewRentalsModal,
  addRentalModal,
  onBreadcrumbClick,
}: HeaderProps) => {
  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        gap: 'default',
        width: '100%',
      }}
    >
      {showBreadcrumb && onBreadcrumbClick && breadcrumbAddress && (
        <Breadcrumb address={breadcrumbAddress} onClick={onBreadcrumbClick} />
      )}
      {!listingSection && (
        <EmptyHeader
          isLoggedIn={isLoggedIn}
          hasMultipleRentals={hasMultipleRentals}
          viewRentalsModal={viewRentalsModal}
          addRentalModal={addRentalModal}
        />
      )}
      {listingSection?.error && <PropertySectionError addRentalModal={addRentalModal} error={listingSection.error} />}
      {listingSection && !listingSection.error && (
        <PropertySection
          listingSection={listingSection}
          hasMultipleRentals={hasMultipleRentals}
          contactIreneModal={contactIreneModal}
          viewRentalsModal={viewRentalsModal}
          addRentalModal={addRentalModal}
        />
      )}
    </Box>
  );
};

export default Header;
